(function(){
  if (window.__cmSf) return; window.__cmSf = true;
  var S = ['S','M','L','XL','2XL','3XL','4XL','5XL','6XL','7XL'];
  // Weight bands in kg, same logic as the market (Ionix / Luveon): 10 kg per size, [min, max) so an exact boundary goes to the bigger size.
  // Our range goes further: 5XL to 7XL extend the same 10 kg steps.
  var W_KG = [60,70,80,90,100,110,120,130,140,Infinity];                 // upper bound per size, kg (S = up to 60 kg / 132 lbs)
  var W_LB = [132,154,176,198,220,243,265,287,309,Infinity];             // same bounds shown in lbs
  // Body measurements per size, aligned with the weight bands (standard US women's sizing)
  var WA_IN = [27,31.5,35,39,43.5,47,51,54.5,58,61.5];                   // waist upper bound, inches
  var H_IN = [37,41.5,45.5,48,51,55.5,59,62.5,66,69.5];                  // hips upper bound, inches
  var LEG_IN = [31.1,31.9,32.7,33.5,34.3,35.0,35.8,36.6,37.4,38.2];      // garment length, waist to hem
  // factory spec, garment unstretched -> fully stretched (cm, inches as printed on the supplier sheet)
  var G_CM = [[58,75,68,88,79],[62,81,72,94,81],[66,86,76,99,83],[70,91,80,104,85],[74,96,84,109,87],[78,101,88,114,89],[82,107,92,120,91],[86,112,96,125,93],[90,117,100,130,95],[94,122,104,135,97]];
  var G_IN = [[22.8,29.7,26.8,34.8,31.1],[24.4,31.7,28.4,36.9,31.9],[26,33.8,29.9,38.9,32.7],[27.6,35.8,31.5,40.9,33.5],[29.1,37.9,33.1,43,34.3],[30.7,39.9,34.7,45,35],[32.3,42,36.2,47.1,35.8],[33.9,44,37.8,49.1,36.6],[35.4,46.1,39.4,51.2,37.4],[37,48.1,40.9,53.2,38.2]];
  var ALIAS = { '2XL': ['2XL','XXL'], '3XL': ['3XL','XXXL'], '4XL': ['4XL','XXXXL'], '5XL': ['5XL','XXXXXL'] };
  var unit = 'us', box, scope, chosen = null, COLORS = {}, K = { el: null, home: null, mo: null, last: null }, applyT, lookT;
  // 28/10 (markets): texts + default units from snippets/cm-sf-i18n.liquid (LOCALIZE translates it); English fallback here
  var I18N = {};
  try { I18N = JSON.parse((document.querySelector('[data-cm-sf-i18n]') || {}).textContent || '{}'); } catch (e) {}
  function tr(k, en, v){ var s = I18N[k] || en; for (var n in (v || {})) s = s.split('{' + n + '}').join(v[n]); return s; }

  function $(s){ return box.querySelector(s); }
  function num(el){ var v = parseFloat((el && el.value || '').replace(',', '.')); return isNaN(v) ? 0 : v; }
  function band(arr, v){ for (var i = 0; i < arr.length; i++) if (v <= arr[i]) return i; return arr.length - 1; }
  function r0(v){ return Math.round(v); }
  function rng(A, i, us){
    var lo = i ? A[i-1] : 0, hi = A[i];
    if (!us){ lo = r0(lo*2.54); hi = r0(hi*2.54); }
    return i ? lo + '–' + hi : tr('under', 'under {n}', { n: hi });
  }

  function table(){
    var tb = $('[data-cm-sf-table] tbody'), rows = '', us = unit === 'us';
    if (tb){
    for (var i = 0; i < S.length; i++){
      var lo = i ? W_LB[i-1] : 0, hi = W_LB[i];
      var w = us ? (i ? (i === S.length-1 ? lo + '+' : lo + '–' + hi) : tr('up_to', 'up to {n}', { n: hi }))
                 : (i ? (i === S.length-1 ? W_KG[i-1] + '+' : W_KG[i-1] + '–' + W_KG[i]) : tr('up_to', 'up to {n}', { n: W_KG[i] }));
      var wa = rng(WA_IN, i, us), hh = rng(H_IN, i, us);
      var leg = us ? LEG_IN[i].toFixed(1) + '″' : r0(LEG_IN[i]*2.54) + ' cm';
      rows += '<tr data-i="' + i + '"><td>' + S[i] + '</td><td>' + w + '</td><td>' + wa + '</td><td>' + hh + '</td><td>' + leg + '</td></tr>';
    }
    tb.innerHTML = rows;
    }
    var gb = $('[data-cm-sf-gtable] tbody');
    if (gb){
      var G = us ? G_IN : G_CM, u = us ? '″' : ' cm', g = '';
      for (var k = 0; k < S.length; k++) g += '<tr data-i="' + k + '"><td>' + S[k] + '</td><td>' + G[k][0] + '–' + G[k][1] + '</td><td>' + G[k][2] + '–' + G[k][3] + '</td><td>' + G[k][4] + u + '</td></tr>';
      gb.innerHTML = g;
      var gu = $('[data-cm-sf-gu]'); if (gu) gu.textContent = us ? tr('g_unit_us', 'inches') : tr('g_unit_metric', 'cm');
    }
    var thw0 = $('[data-cm-sf-th-w]'); if (thw0) thw0.textContent = us ? tr('th_weight_us', 'Weight (lbs)') : tr('th_weight_metric', 'Weight (kg)');
    var thh = $('[data-cm-sf-th-h]'); if (thh) thh.textContent = us ? tr('th_hips_us', 'Hips (in)') : tr('th_hips_metric', 'Hips (cm)');
    var thw = $('[data-cm-sf-th-wa]'); if (thw) thw.textContent = us ? tr('th_waist_us', 'Waist (in)') : tr('th_waist_metric', 'Waist (cm)');
    mark(chosen ? S.indexOf(chosen) : -1);
  }
  function mark(i){ box.querySelectorAll('[data-cm-sf-table] tr[data-i],[data-cm-sf-gtable] tr[data-i]').forEach(function(tr){ tr.classList.toggle('is-me', +tr.dataset.i === i); }); }

  function hasH(){
    if (unit === 'us' && ($('[data-cm-sf-ft]').value.trim() === '' || $('[data-cm-sf-inch]').value.trim() === '')) return false;
    var hIn = unit === 'us' ? num($('[data-cm-sf-ft]')) * 12 + num($('[data-cm-sf-inch]')) : num($('[data-cm-sf-cm]')) / 2.54;
    return hIn >= 54 && hIn <= 80;
  }
  function legNote(i){
    var hIn = unit === 'us' ? num($('[data-cm-sf-ft]')) * 12 + num($('[data-cm-sf-inch]')) : num($('[data-cm-sf-cm]')) / 2.54;
    if (hIn < 54 || hIn > 80) return '';
    var r = LEG_IN[i] / (hIn * 0.5);
    var ht = unit === 'us' ? Math.floor(hIn/12) + '′' + Math.round(hIn % 12) + '″' : Math.round(hIn*2.54) + ' cm';
    if (r < 0.93) return tr('leg_above', ' At {h} they end a little above your ankle.', { h: ht });
    if (r > 1.06) return tr('leg_gather', ' At {h} they gather softly at your ankle.', { h: ht });
    return tr('leg_ankle', ' At {h} the leg ends at your ankle.', { h: ht });
  }

  /* ---------- step 1 ---------- */
  function calc(){
    var wv = num($('[data-cm-sf-w]')), hv = num($('[data-cm-sf-hips]'));
    var lb = unit === 'us' ? wv : wv * 2.2046;
    var hin = unit === 'us' ? hv : hv / 2.54;
    var res = $('[data-cm-sf-res]'), alt = $('[data-cm-sf-alt]'), hint = $('[data-cm-sf-hint]');
    var best, snug = -1, why;
    if (!hasH() || !(lb >= 70 && lb <= 600)){
      hint.textContent = (lb >= 70 && lb <= 600) ? (unit === 'us' ? tr('hint_height_us', 'Now add your height (feet and inches) to see your size.') : tr('hint_height_metric', 'Now add your height to see your size.')) : tr('hint_start', 'Enter your weight and height and we\'ll match you to the chart.');
      res.hidden = alt.hidden = true; hint.hidden = false; mark(-1); return;
    }
    if (hin >= 24 && hin <= 70){
      best = band(H_IN, hin);
      why = tr('why_hips', 'Matched on your hips, the most precise way to size compression.');
    } else if (lb >= 70 && lb <= 600){
      var kg = lb / 2.2046, i = 0;
      while (i < S.length - 1 && kg >= W_KG[i]) i++;
      best = i;
      if (i > 0 && kg - W_KG[i-1] < 1){ snug = i - 1; why = tr('why_between', 'You\'re right on the line between {a} and {b}. {a} gives a closer sculpting fit; {b} gives more ease.', { a: S[i-1], b: S[i] }); }
      else why = tr('why_weight', 'Women your weight and height wear {s} most comfortably: firm hold, no digging at the waist.', { s: S[i] });
      if (kg > 150) why = tr('why_largest', '{s} is our largest size. Add your hip measurement below to be sure.', { s: S[9] });
    } else {
      res.hidden = alt.hidden = true; hint.hidden = false; mark(-1); return;
    }
    why += legNote(best);
    hint.hidden = true; res.hidden = false;
    $('[data-cm-sf-size]').textContent = S[best];
    $('[data-cm-sf-title]').textContent = tr('recommend', 'We recommend {s}', { s: S[best] });
    $('[data-cm-sf-why]').textContent = why;
    if (snug >= 0){
      alt.hidden = false;
      alt.innerHTML = '<button type="button" data-cm-sf-alt-size="' + S[snug] + '">' + tr('snugger', 'Snugger') + '<b>' + S[snug] + '</b></button>' +
                      '<button type="button" class="is-on" data-cm-sf-alt-size="' + S[best] + '">' + tr('best_fit', 'Best fit') + '<b>' + S[best] + '</b></button>';
    } else { alt.hidden = true; alt.innerHTML = ''; }
    choose(S[best]);
  }

  function choose(size){
    var first = !chosen;
    chosen = size;
    mark(S.indexOf(size));
    $('[data-cm-sf-s2size]').textContent = size;
    var s2 = $('[data-cm-sf-step2]');
    s2.hidden = false;
    clearTimeout(applyT);
    applyT = setTimeout(function(){ applySize(size); look(); }, first ? 50 : 350);
    if (first) setTimeout(function(){ var bx = $('.cm-sf__box') || box.querySelector('.cm-sf__box'); var y = s2.offsetTop - 140; if (bx && y > bx.scrollTop) bx.scrollTo({ top: y, behavior: 'smooth' }); }, 900);
  }

  function applySize(size){
    var roots = [K.el, scope || document].filter(Boolean), names = ALIAS[size] || [size];
    roots.forEach(function(root){
      root.querySelectorAll('select').forEach(function(sel){
        for (var k = 0; k < sel.options.length; k++){
          var t = (sel.options[k].text || sel.options[k].value || '').trim().toUpperCase();
          if (names.indexOf(t) > -1 || names.indexOf(t.split(/\s|\//)[0]) > -1){
            if (sel.selectedIndex !== k){ sel.selectedIndex = k; sel.dispatchEvent(new Event('input', {bubbles:true})); sel.dispatchEvent(new Event('change', {bubbles:true})); }
            break;
          }
        }
      });
      root.querySelectorAll('input[type=radio]').forEach(function(r){
        if (names.indexOf((r.value || '').trim().toUpperCase()) > -1 && !r.checked) r.click();
      });
    });
  }

  /* ---------- step 2: Kaching inside the drawer ---------- */
  function mountK(){
    if (K.el) return;
    var k = (scope && scope.querySelector('kaching-bundle, cm-bundle')) || document.querySelector('kaching-bundle, cm-bundle');
    if (!k) return;
    K.home = document.createComment('cm-kaching-home');
    k.parentNode.insertBefore(K.home, k);
    $('[data-cm-sf-kslot]').appendChild(k);
    K.el = k;
    K.mo = new MutationObserver(function(list){
      list.forEach(function(m){
        if (m.type === 'attributes' && m.target.dataset && /col/i.test(m.target.dataset.name || '')) K.last = m.target.dataset.value;
      });
      clearTimeout(lookT); lookT = setTimeout(look, 80);
    });
    K.mo.observe(k, { subtree: true, childList: true, attributes: true, attributeFilter: ['data-value', 'class'] });
    k.addEventListener('click', onKClick);
    k.addEventListener('change', function(e){ if (e.target.tagName === 'SELECT' && COLORS[(e.target.value || '').toLowerCase()]) K.last = e.target.value; clearTimeout(lookT); lookT = setTimeout(look, 80); });
  }
  function unmountK(){
    if (!K.el) return;
    K.el.removeEventListener('click', onKClick);
    if (K.mo) K.mo.disconnect();
    K.home.parentNode.insertBefore(K.el, K.home);
    K.home.remove();
    K.el = null; K.mo = null;
  }
  function onKClick(e){
    if (e.target.closest('select, .kaching-bundles__swatch-dropdown, .kaching-bundles__bar-variant-select')) return;
    if (e.target.closest('.kaching-bundles__bar, .cmb__bar') && chosen) { setTimeout(function(){ applySize(chosen); look(); }, 250); }
  }
  function selectedColors(){
    if (!K.el) return [];
    var bar = K.el.querySelector('.kaching-bundles__bar--selected') || K.el.querySelector('[data-cmb-units]') || K.el, out = [];
    bar.querySelectorAll('.kaching-bundles__swatch-dropdown[data-name]').forEach(function(d){ if (/col/i.test(d.dataset.name) && d.dataset.value) out.push(d.dataset.value); });
    if (!out.length) bar.querySelectorAll('select').forEach(function(s){ var v = s.value || ''; if (COLORS[v.toLowerCase()]) out.push(v); });
    return out;
  }
  function look(){
    var cols = selectedColors(), img = $('[data-cm-sf-img]'), cap = $('[data-cm-sf-color]'), pairs = $('[data-cm-sf-pairs]');
    var main = (K.last && cols.indexOf(K.last) > -1) ? K.last : cols[0];
    if (main && COLORS[main.toLowerCase()] && img.getAttribute('src') !== COLORS[main.toLowerCase()]) img.src = COLORS[main.toLowerCase()];
    cap.hidden = !main; if (main) cap.textContent = main + (chosen ? ' · ' + chosen : '');
    if (cols.filter(function(c, i){ return cols.indexOf(c) === i; }).length > 1){
      pairs.innerHTML = cols.map(function(c, i){ var u = COLORS[c.toLowerCase()] || img.src; return '<span' + (c === main ? ' class="is-on"' : '') + '><img src="' + u + '" alt=""><small>' + tr('pair', 'Pair {n}', { n: i + 1 }) + '<br>' + c + '</small></span>'; }).join('');
      pairs.hidden = false;
    } else { pairs.innerHTML = ''; pairs.hidden = true; }
    var price = K.el && K.el.querySelector('.kaching-bundles__bar--selected .kaching-bundles__bar-price, .cmb__set:not([hidden]) .cmb__bar:has(input:checked) .cmb__price b');
    $('[data-cm-sf-atc]').textContent = tr('atc', 'Add to cart') + (price && price.textContent.trim() ? ' · ' + price.textContent.trim() : '');
  }
  function addToCart(){
    // 28/10: the bundle sits in the drawer while it is open (moved out of scope), so take its own button first
    var btn = (K.el && K.el.querySelector('[data-cmb-atc]')) || (scope || document).querySelector('cm-bundle [data-cmb-atc]') || (scope || document).querySelector('form[action*="/cart/add"] [type=submit]');
    close();
    if (btn) setTimeout(function(){ btn.click(); }, 60);
  }

  /* ---------- open / close ---------- */
  function open(btn){
    scope = btn.closest('.shopify-section') || document;
    box.hidden = false; document.documentElement.classList.add('cm-lock');
    mountK();
    if (chosen) { applySize(chosen); look(); }
    setTimeout(function(){ $('[data-cm-sf-w]').focus({ preventScroll: true }); }, 60);
  }
  function close(){ unmountK(); box.hidden = true; document.documentElement.classList.remove('cm-lock'); }

  function init(){
    box = document.querySelector('[data-cm-sf]'); if (!box) return;
    try { COLORS = JSON.parse((document.querySelector('[data-cm-sf-colors]') || {}).textContent || '{}'); } catch (e) { COLORS = {}; }
    document.body.appendChild(box);
    var mv = document.querySelector('[data-cm-sf-move]'), atc = document.querySelector('cm-bundle [data-cmb-atc]') || document.querySelector('form[action*="/cart/add"] [type=submit]'), bb = atc && (atc.closest('cm-bundle') ? atc : (atc.closest('buy-buttons') || atc.parentElement));
    // with our bundle (Farid 26/10): the "Find my size" button sits right above Add to cart, inside the bundle
    if (mv && bb){
      var row = document.createElement('div'); row.className = 'cm-sf-row';
      var oldWrap = mv.parentElement; row.appendChild(mv); bb.parentNode.insertBefore(row, bb);
      if (oldWrap && oldWrap.classList.contains('cm-bb-size') && !oldWrap.querySelector('button')) oldWrap.style.display = 'none';
    }
    table();
    box.addEventListener('input', function(e){ if (!e.target.closest('[data-cm-sf-kslot]')) calc(); });
    box.addEventListener('click', function(e){
      var u = e.target.closest('[data-cm-sf-unit]');
      if (u){
        var next = u.dataset.cmSfUnit; if (next === unit) return;
        var w = $('[data-cm-sf-w]'), h = $('[data-cm-sf-hips]');
        if (w.value) w.value = next === 'us' ? r0(num(w) * 2.2046) : r0(num(w) / 2.2046);
        if (h.value) h.value = next === 'us' ? (num(h) / 2.54).toFixed(1) : r0(num(h) * 2.54);
        unit = next;
        box.querySelectorAll('[data-cm-sf-unit]').forEach(function(b){ b.classList.toggle('is-on', b === u); });
        $('[data-cm-sf-wu]').textContent = unit === 'us' ? 'lbs' : 'kg';
        $('[data-cm-sf-hu]').textContent = unit === 'us' ? 'in' : 'cm';
        $('[data-cm-sf-w]').placeholder = unit === 'us' ? '160' : '72';
        $('[data-cm-sf-h-us]').hidden = unit !== 'us'; $('[data-cm-sf-h-metric]').hidden = unit === 'us';
        table(); calc(); return;
      }
      var a = e.target.closest('[data-cm-sf-alt-size]');
      if (a){ box.querySelectorAll('[data-cm-sf-alt-size]').forEach(function(b){ b.classList.toggle('is-on', b === a); }); choose(a.dataset.cmSfAltSize); return; }
      if (e.target.closest('[data-cm-sf-atc]')){ addToCart(); return; }
      if (e.target.closest('[data-cm-sf-close]')) close();
    });
    // default units per market (cm-sf-i18n: imperial for US / UK, metric elsewhere); the drawer's HTML starts on imperial
    if (I18N.unit === 'metric') { var mu = box.querySelector('[data-cm-sf-unit="metric"]'); if (mu) mu.click(); }
    document.addEventListener('click', function(e){ var b = e.target.closest('[data-cm-sf-open]'); if (b && !box.contains(b)){ e.preventDefault(); open(b); } });
    document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && !box.hidden) close(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();